import React, { useState, createContext, useRef } from 'react';

export interface SelectDetailedProviderValues {
    activeSelectDetailedId: string;
    changeActiveSelectDetailedId: (id: string) => void;
    generateSelectDetailedUniqueId: () => string;
    preventClose: boolean;
    setPreventClose: (value: boolean) => void;
}

export const SelectDetailedContext = createContext<SelectDetailedProviderValues>({
    activeSelectDetailedId: '',
    changeActiveSelectDetailedId: () => {},
    generateSelectDetailedUniqueId: () => '',
    preventClose: false,
    setPreventClose: () => {}
});

interface SelectDetailedProviderProps {
    children: React.ReactNode;
}

export default function SelectDetailedProvider({ children }: SelectDetailedProviderProps): JSX.Element {
    const [activeSelectDetailedId, setActiveSelectDetailedId] = useState<string>('');
    const selectIdRef = useRef<number>(0);
    const [preventClose, setPreventClose] = useState<boolean>(false);

    const generateSelectDetailedUniqueId = (): string => {
        selectIdRef.current += 1;
        return `select-detailed-${selectIdRef.current}`;
    };

    const changeActiveSelectDetailedId = (id: string): void => {
        setActiveSelectDetailedId(id);
    };

    return (
        <SelectDetailedContext.Provider
            value={{
                activeSelectDetailedId,
                changeActiveSelectDetailedId,
                generateSelectDetailedUniqueId,
                preventClose,
                setPreventClose
            }}
        >
            {children}
        </SelectDetailedContext.Provider>
    );
}
